/**
 * ✅ ADİSYON YAZDIRILDIKTAN SONRA ÜRÜN EKLEME ONAY MODALI
 * Yetkili garsonlar için adisyon yazdırılmış masaya ürün eklemeden önce onay ister.
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface ReceiptPrintedConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tableName: string;
  productName?: string;
}

const ReceiptPrintedConfirmModal: React.FC<ReceiptPrintedConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  tableName,
  productName,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="receipt-printed-confirm-dialog-title"
      aria-describedby="receipt-printed-confirm-dialog-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="receipt-printed-confirm-dialog-title">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmberIcon color="warning" fontSize="large" />
          <Typography variant="h6" component="span">
            Adisyon Yazdırılmış
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="receipt-printed-confirm-dialog-description">
          <Typography variant="body1" sx={{ mb: 2 }}>
            <strong>{tableName}</strong> masasının adisyonu daha önce yazdırılmıştır.
          </Typography>
          {productName && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Eklemek istediğiniz ürün: <strong>{productName}</strong>
            </Typography>
          )}
          <Typography variant="body1" color="warning.main" sx={{ fontWeight: 'bold' }}>
            Yine de devam etmek istiyor musunuz?
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Not: Ürün ekledikten sonra müşteriye yeni bir adisyon yazdırmanız gerekebilir.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">
          İptal
        </Button>
        <Button onClick={onConfirm} variant="contained" color="warning" autoFocus>
          Evet, Devam Et
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReceiptPrintedConfirmModal;
